<template>
  <div class="page_salary">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName">
          <el-tab-pane label="发放途径配置" name="0"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <!-- <el-button type="primary" size="small" @click="showAddRoad = true">+新增</el-button> -->
          <el-button type="primary" size="small" @click="addCompany">+新增落地公司</el-button>
        </div>

        <!-- <div class="roadBox">
          <div class="headLine flex">
            <div class="titleItem">途径名称</div>
            <div class="titleItem">平台</div>
            <div class="titleItem">落地公司</div>
            <div class="titleItem">收款抬头</div>
            <div class="titleItem">收款银行</div>
            <div class="titleItem">开户行</div>
            <div class="titleItem">收款账号</div>
            <div class="titleItem">费率</div>
            <div class="titleItem">打款方式</div>
            <div class="titleItem">启用状态</div>
            <div class="titleItem">备注</div>
            <div class="titleItem"></div>
          </div>
          <div class="content" v-for="(item,index) in 2" :key="index">
            <div class="contentLine flex" v-for="(item,index) in 2" :key="index">
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem">XXX</div>
              <div class="contentItem injuryTabBtn">
                <el-button type="text">停用</el-button>
                <el-button type="text">配置</el-button>
              </div>
            </div>
            <div class="injuryTabBtn" style="margin-left: 30px;">
              <el-button type="text" @click="showAddCompany = true">新增落地公司</el-button>
            </div>
          </div>
        </div> -->

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:1201px">
          <el-table-column prop="ChannelName" label="途径名称" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Account" label="平台" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CompanyNameOptional" label="落地公司" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CollectionOrder" label="收款抬头" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="DueBank" label="收款银行" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="BankBranch" label="开户行" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ShroffAccount" label="收款账号" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="StateStr" label="费率" width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.Rate.r1 ? '实发金额 ≤' + row.Rate.a1 + '=' + row.Rate.r1  + '；': ''}}{{ row.Rate.r2 ? row.Rate.a21 + '≤ 实发金额 ≤' + row.Rate.a22 + '=' + row.Rate.r2 + '；' : ''}}{{ row.Rate.r3 ? '实发金额 ≥' + row.Rate.a3 + '=' + row.Rate.r3  : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="RechargeMethod" label="打款方式" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="StateStr" label="启用状态" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark" label="备注" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="100px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-popconfirm :title="row.StateStr=='启用' ? '请确定是否停用？' : '请确定是否启用？'" @confirm="stopHandle(row)" style="margin-right: 10px;">
                  <el-button type="text" slot="reference">{{row.StateStr=='启用' ? '停用' : '启用'}}</el-button>
                </el-popconfirm>
                <el-button type="text" @click="edit(row)">修改</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog title="新增发放途径" :visible.sync="showAddRoad" width="500px">
      <el-form :model="formData" ref="formData" :rules="rules" label-width="100px">
        <el-form-item label="途径名称" prop="name">
          <el-input v-model="formData.name" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="平台" prop="name">
          <el-input v-model="formData.name" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddRoad = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="showAddRoad = false">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增落地公司" :visible.sync="showAddCompany" width="1000px">
      <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="100px">
        <el-form-item label="途径名称">
          <!-- <div class="formItem">XXX</div> -->
          <el-input v-model="formData.model.ChannelName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="平台">
          <el-input v-model="formData.model.name" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="落地公司" prop="CompanyNameOptional">
          <el-input v-model="formData.model.CompanyNameOptional" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收款抬头" prop="CollectionOrder">
          <el-input v-model="formData.model.CollectionOrder" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收款银行" prop="DueBank">
          <el-input v-model="formData.model.DueBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="BankBranch">
          <el-input v-model="formData.model.BankBranch" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收款账号" prop="ShroffAccount">
          <el-input v-model="formData.model.ShroffAccount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="打款方式" prop="RechargeMethod">
          <el-input v-model="formData.model.RechargeMethod" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="费率">
          <div class="flex aic">

            <el-input v-model="formData.RateJ.r1" placeholder="费率" style="width:100px;" size="small"></el-input>

            <div class="condition"> 条件</div>
            <div class="rate flex aic">
              <div class="symbol sfje">实发金额 ≤</div>
              <el-input v-model="formData.RateJ.a1" style="width:100px;" size="small"></el-input>
              
            </div>
            <div class="injuryTabBtn" style="margin-left: 20px;">
              <!-- <el-button type="text" @click="delRateItem">删除</el-button> -->
              <!-- <el-button type="text" @click="addRateItem">增加</el-button> -->
            </div>
          </div>
          <div class="flex aic">
            <el-input v-model="formData.RateJ.r2" placeholder="费率" style="width:100px;" size="small"></el-input>
            <div class="condition"> 条件</div>
            <div class="rate flex aic">
              <el-input v-model="formData.RateJ.a21" style="width:100px;" size="small"></el-input>
              <div class="symbol sfje">≤ 实发金额 ≤</div>
              <el-input v-model="formData.RateJ.a22" style="width:100px;" size="small"></el-input>
              <!-- <div class="symbol"> = </div> -->
              
            </div>
          </div>
          <div class="flex aic">
             <el-input v-model="formData.RateJ.r3" placeholder="费率" style="width:100px;" size="small"></el-input>
             <div class="condition"> 条件</div>
            <div class="rate flex aic">
              <div class="symbol sfje">实发金额 ≥</div>
              <el-input v-model="formData.RateJ.a3" style="width:100px;" size="small"></el-input>
              <!-- <div class="symbol"> = </div> -->
             
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddCompany = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddCompany">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          ChannelName: '',
          pageNum: 1,
          pageSize: 10,
        },
        roletype: localStorage.loginRoletype,
        activeName: 0,
        totalCount: 0,
        loading: false,
        tableData: [],
        formData: {
          model: {
            Id: '',
            ChannelName: '', //渠道名称
            CompanyNameOptional: '', //落地公司名称选填
            RechargeMethod: '', //打款充值方式
            CollectionOrder: '', //收款抬头
            DueBank: '', //收款银行
            ShroffAccount: '', //收款账号
            BankBranch: '', //开户支行
            DisableorNot: '启用', //是否停用
          },
          RateJ: {
            a1: '',
            r1: '',
            a21: '',
            a22: '',
            r2: '',
            a3: '',
            r3: '',
          }, //费率
        },
        rules: {
          name: {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
        },
        showAddRoad: false, //新增途径弹窗
        showAddCompany: false, //新增落地公司弹窗
      }
    },
    created() {
      this.getDistributionChannelList();
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getDistributionChannelList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getDistributionChannelList();
      },
      //发放途径列表
      getDistributionChannelList() {
        xz.getDistributionChannelList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            res.data.data.forEach(element => {
              element.Rate = JSON.parse(element.Rate);
            });
            this.tableData = res.data.data;
            this.totalcount = res.data.totalcount;
          } else {
            this.$message.error('保存失败');
          }
        })
      },
      stopHandle(row) {
        let stopForm = {
          type: type, // 1到款银行 2 开票抬头 3发薪主体 4\发放途径
          StateStr: row.StateStr == '启用' ? '停用' : '启用', //状态
          id: row.Id,
        }
        xz.updataCollectingBankstateStr(stopForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.getDistributionChannelList();
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      addCompany() {
        this.formData = {
          model: {
            ChannelName: '', //渠道名称
            CompanyNameOptional: '', //落地公司名称选填
            RechargeMethod: '', //打款充值方式
            CollectionOrder: '', //收款抬头
            DueBank: '', //收款银行
            ShroffAccount: '', //收款账号
            BankBranch: '', //开户支行
            DisableorNot: '', //是否停用
          },
          RateJ: {
            a1: '',
            r1: '',
            a21: '',
            a22: '',
            r2: '',
            a3: '',
            r3: '',
          } //费率
        }
        this.showAddCompany = true;
      },
      edit(row) {
        this.formData.model = row;
        this.formData.RateJ = row.Rate;
        this.formData.model.Rate = '';
        this.showAddCompany = true;
      },
      confirmAddCompany() {
        xz.addDistributionChannel(this.formData, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.getDistributionChannelList();
            this.showAddCompany = false;
          } else {
            this.$message.error('保存失败');
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .roadBox {
    // width: 1050px;
    overflow-x: auto;
  }

  .headLine {
    margin-bottom: 15px;
  }

  .titleItem {
    min-width: 110px;
    text-align: center;
    margin-right: 10px;
  }

  .content {
    background: #E8F7F7;
    padding: 12px 0px;
    width: 1440px;
    margin-top: 20px;
  }

  .contentLine {
    margin-bottom: 10px;
  }

  .contentItem {
    min-width: 110px;
    text-align: center;
    margin-right: 10px;
  }

  .formItem {
    width: 300px;
  }

  .rate {
    height: 40px;
    line-height: 40px;
  }

  .sfje {
    width: 80px;
  }

  .symbol {
    color: #000;
    height: 32px;
    line-height: 32px;
    margin: 0 10px;
  }
  .condition{
    color: #606266;
    margin:0 10px 0 50px;
  }
</style>
<style>
  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>